/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import TableHeadColumn from "./TableHeadColumn";
import DataProvider from "../../../DataProvider";

class TableHead extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        /**
         * Sort specification
         */
        sort: PropTypes.arrayOf(PropTypes.string),
        /**
         * Callback called when user click's on column header. Signature:
         * onSort(sortfield)
         */
        onSort: PropTypes.func,
        appendEmptyColumns: PropTypes.number,
        hideRecColumn: PropTypes.bool
    };

    static defaultProps = {
        appendEmptyColumns: 0,
        hideRecColumn: false
    };

    constructor(props) {
        super(props);
        this.state = {
            sort: (props.sort ? props.sort[0] : null)
        };
        this.onSort = this.onSort.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sort != nextProps.sort)
            this.setState({
                sort: (nextProps.sort ? nextProps.sort[0] : null)
            });
    }

    onSort(field) {
        if (this.props.onSort) this.props.onSort([field]);
    }

    renderEmptyColumns() {
        if (!this.props.appendEmptyColumns) return null;
        let result = [];
        for (let i = this.props.appendEmptyColumns; i > 0; i--) {
            result.push(<th key={"e"+i}></th>);
        }
        return result;
    }

    render() {
        /**
         *
         * @type {Schema}
         */
        let schema = this.props.dataProvider.getRecordSchema();
        let fieldList = schema.getFieldList();
        if (!fieldList) return null;
        let idProperty = schema.getIdProperty();
        return (
            <thead>
                <tr>
                    {
                        this.props.hideRecColumn ? null :
                            <TableHeadColumn key="0" field={idProperty} title="#" sort={this.state.sort} onSort={this.props.onSort ? this.onSort : null}/>
                    }
                    {
                        _.map(fieldList, function (field) {
                            return (<TableHeadColumn
                                key={field}
                                field={field}
                                title={schema.field(field).getTitle()}
                                sort={this.state.sort}
                                onSort={this.props.onSort ? this.onSort : null}/>);
                        }.bind(this))
                    }
                    {this.renderEmptyColumns()}
                </tr>
            </thead>
        );
    }
}

export default TableHead;
